import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import withFieldError from 'components/form/with-error'

const MessageInput = ({ input, placeholder }) => (
  <div>
    <input
      className={'form-control right-element-no-borders '}
      type='text'
      placeholder={placeholder}
      {...input}
    />
  </div>
)

MessageInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any,
  placeholder: PropTypes.string
}

const MessageInputWithError = withFieldError(MessageInput)

const InstagramCommentReplyFields = ({ name }) => {
  return (
    <div className='row'>
      <div className='col-sm-12'>
        <Field
          component={MessageInputWithError}
          label='Message'
          name={`${name}.igCommentReplyMessage`}
          placeholder='Message'
        />
      </div>
    </div>
  )
}

InstagramCommentReplyFields.propTypes = {
  name: PropTypes.string
}

export default InstagramCommentReplyFields



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/instagram/instagram-comment-reply/index.js